import { Plus } from "lucide-react";
import { useState } from "react";
import { useParams } from "react-router-dom";

import { ActionsAgainstInvolvedPartiesModal } from "../../reporting/components/common/ViewOrAddRecommendation";
import NoDataIcon from "../../../assets/svg/EmptyTableIcon";

export default function EmptyRecommendationState() {
  const { id: caseId } = useParams<{ id: string }>();

  const [showModal, setShowModal] = useState(false);

  return (
    <>
      <div className="flex h-[574px] items-center justify-center rounded-b-[14px] rounded-t-none border border-[#E5E5E5] bg-white px-6 py-4">
        <div className="flex w-[480px] flex-col items-center gap-6 p-6">
          <NoDataIcon />

          <div className="flex w-[304px] flex-col items-center gap-2">
            <h3 className="text-center text-base font-semibold leading-6 text-[#0A0A0A]">
             No fraud elements created yet
            </h3>

            <p className="text-center text-sm leading-5 text-[#737373]">
             Add "Issue SCN" as a recommended action for at least one party before creating fraud elements.
            </p>
          </div>

          <button
            type="button"
            onClick={() => setShowModal(true)}
            className="flex h-9 items-center justify-center gap-2 rounded-[8px] bg-gradient-to-b from-[#788AF7] to-[#3551F3] px-4 py-2 text-sm font-medium leading-5 text-[#FEF2F2] shadow-[0_1px_2px_rgba(0,0,0,0.05)] transition-all hover:opacity-90"
          >
            <Plus className="h-4 w-4 text-[#FEF2F2]" />
            Issue SCN Recommendations
          </button>
        </div>
      </div>

      {showModal && caseId && (
        <ActionsAgainstInvolvedPartiesModal
          caseId={caseId}
          onClose={() => setShowModal(false)}
        />
      )}
    </>
  );
}
